import { MessageCircle } from "lucide-react";
import { CONTACT } from "../data/site";

const GREETING = encodeURIComponent(
  "Hello Durgastra Innovations, I'd like to enquire about your drones / kits / training.",
);

/** Always-visible WhatsApp shortcut, straight to the primary number. */
export const WhatsAppFab = () => (
  <a
    className="wa-fab"
    href={`https://wa.me/${CONTACT.whatsApp}?text=${GREETING}`}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with us on WhatsApp"
  >
    <MessageCircle size={24} strokeWidth={2} />
    <span className="wa-fab-label">WhatsApp Us</span>
  </a>
);
